import { gql } from '@apollo/client';
import { getGraphqlClient } from "./ApolloClient";

export const getQueryResult = (gql, variables) => {
    return getGraphqlClient().query({query:gql, variables: variables}).catch(function(error) {
        console.log(error.message)
    });
}

export const getMutationResult = (gql, variables) => {
    return getGraphqlClient().mutate({mutation:gql, variables: variables}).catch(function(error) {
        console.log(error.message)
    });
}

export const getUserRegisterSerialNumberQuery = () => {
    return gql`
        query SupportSiteUserRegisterCheckSerialNumber($serialNumber1: String!){
            supportSiteUserRegisterCheckSerialNumber(
                serialNumber1: $serialNumber1
            )
        }
    `
}

export const getUserRegisterZipcodeQuery = () => {
    return gql`
        query supportSiteUserRegisterCheckZipcode($serialNumber1: String!, $zipcode: String!){
            supportSiteUserRegisterCheckZipcode(
                serialNumber1: $serialNumber1,
                zipcode: $zipcode
            )
        }
    `
}

export const postUserRegisterCreateAccount = (previousForm) => {
    if (previousForm === 'zipForm') {
        return gql`
            mutation supportSiteUserRegisterCreateAccount($serialNumber1: String!, $zipcode: String!, $firstName: String!, $lastName: String!, $userName: String!, $userPassword: String!){
                supportSiteUserRegisterCreateAccount(
                    serialNumber1: $serialNumber1,
                    zipcode: $zipcode,
                    firstName: $firstName,
                    lastName: $lastName,
                    userName: $userName,
                    userPassword: $userPassword
                )
            }
        `
    }
    if (previousForm === 'regionForm') {
        return gql`
            mutation supportSiteUserRegisterCreateAccount($serialNumber1: String!, $region: String!, $firstName: String!, $lastName: String!, $userName: String!, $userPassword: String!){
                supportSiteUserRegisterCreateAccount(
                    serialNumber1: $serialNumber1,
                    region: $region,
                    firstName: $firstName,
                    lastName: $lastName,
                    userName: $userName,
                    userPassword: $userPassword
                )
            }
        `
    }
}

export const getUserActivationToken = () => {
    return gql`
        query supportSiteUserActivationCheckToken($token: String!){
            supportSiteUserActivationCheckToken(
                token: $token
            )
        }
    `
}

export const postUserRecoverPasswordReset = () => {
    return gql`
        mutation supportSiteUserRecoverPasswordReset($emailAddress: String!){
            supportSiteUserRecoverPasswordReset(
                emailAddress: $emailAddress
            )
        }
    `
}

export const getUserPasswordResetToken = (type) => {
    if (type === "checkToken") {
        return gql`
            query supportSiteUserPasswordResetCheckToken($token: String!){
                supportSiteUserPasswordResetCheckToken(
                    token: $token
                )
            }
        `
    }
    if (type === "submitPassword") {
        return gql`
            query supportSiteUserPasswordResetCheckToken($token: String!, $password: String!){
                supportSiteUserPasswordResetCheckToken(
                    token: $token, 
                    password: $password
                )
            }
        `
    }
}

export const getRegionList = () => {
    return gql`
        query supportSiteUserGetRegion($getRegion: String!){
            supportSiteUserGetRegion(
                getRegion: $getRegion
            )
        }
    `
}

export const getUserRegisterRegionQuery = () => {
    return gql`
        query supportSiteUserRegisterCheckRegion($serialNumber1: String!, $region: String!){
            supportSiteUserRegisterCheckRegion(
                serialNumber1: $serialNumber1,
                region: $region
            )
        }
    `
}